import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-module-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './module-form.html',
})
export class ModuleForm implements OnInit {
  @Input() moduleId: string | null = null;
  @Input() moduleName = '';
  @Input() moduleDescription = '';
  @Input() moduleContentType: 'lessons' | 'evaluations' | null = null;
  @Output() save = new EventEmitter<{
    name: string;
    description: string;
    contentType: 'lessons' | 'evaluations';
  }>();
  @Output() cancelClick = new EventEmitter<void>();

  private readonly fb = inject(FormBuilder);
  protected moduleForm!: FormGroup;

  protected contentTypeOptions = [
    { value: 'lessons', label: 'Lições', icon: 'bi-book' },
    { value: 'evaluations', label: 'Avaliações', icon: 'bi-clipboard-check' },
  ];

  ngOnInit(): void {
    this.moduleForm = this.fb.group({
      contentType: [this.moduleContentType || 'lessons', [Validators.required]],
      name: [
        this.moduleName || '',
        [Validators.required, Validators.minLength(3)],
      ],
      description: [
        this.moduleDescription || '',
        [Validators.required, Validators.minLength(10)],
      ],
    });
  }

  protected get isEditMode(): boolean {
    return !!this.moduleId;
  }

  protected onSave(): void {
    if (this.moduleForm.invalid) {
      this.moduleForm.markAllAsTouched();
      return;
    }

    const formValue = this.moduleForm.value;
    this.save.emit({
      name: formValue.name,
      description: formValue.description,
      contentType: formValue.contentType,
    });
  }

  protected onCancel(): void {
    this.cancelClick.emit();
  }

  protected getFieldError(fieldName: string): string {
    const field = this.moduleForm.get(fieldName);
    if (!field || !field.errors || !field.touched) {
      return '';
    }

    if (field.errors['required']) {
      return 'Este campo é obrigatório';
    }
    if (field.errors['minlength']) {
      const requiredLength = field.errors['minlength'].requiredLength;
      return `Deve ter pelo menos ${requiredLength} caracteres`;
    }

    return '';
  }

  protected isFieldInvalid(fieldName: string): boolean {
    const field = this.moduleForm.get(fieldName);
    return !!(field && field.invalid && field.touched);
  }
}
